import { render } from "./form-detail.vue?vue&type=template&id=0779b5d8"
import script from "./form-detail.vue?vue&type=script&lang=js"
export * from "./form-detail.vue?vue&type=script&lang=js"

import "./form-detail.vue?vue&type=style&index=0&id=0779b5d8&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__